import Tooltip from 'components/cosmos/tooltip';

const setPosition = (
  mobilePosition = Tooltip.TOOLTIP_POSITION.TOP,
  desktopPosition = Tooltip.TOOLTIP_POSITION.RIGHT,
  isMobile = true
) => (isMobile ? mobilePosition : desktopPosition);

export { setPosition };
